module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_invite_default_dark.65ff0.png";